 import { initializeApp } from "firebase/app";
 import { getFirestore } from "firebase/firestore";

 // TODO: Add SDKs for Firebase products that you want to use
 // https://firebase.google.com/docs/web/setup#available-libraries
 // Your web app's Firebase configuration
 const firebaseConfig = {
    apiKey: 'AIzaSyBdi4w1cye25IME_ao6BtCSSRDwW-g2JiM',
    appId: '1:590507975695:web:34f0965b24a63e658a6f7a',
    messagingSenderId: '590507975695',
    projectId: 'integraapp-b73aa',
    authDomain: 'integraapp-b73aa.firebaseapp.com',
    storageBucket: 'integraapp-b73aa.appspot.com',
    measurementId: 'G-TN413MR38X',
 };
 // Initialize Firebase
 
 const app = initializeApp(firebaseConfig);
 // Export firestore database
 // It will be imported into your react app whenever it is needed
 export const db = getFirestore(app);